import { render, staticRenderFns } from "./ModalAddConfirmPerson.vue?vue&type=template&id=2b7efde6&scoped=true&"
import script from "./ModalAddConfirmPerson.vue?vue&type=script&lang=js&"
export * from "./ModalAddConfirmPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7efde6",
  null
  
)

export default component.exports